import { extrasVM } from '../Extras.page';
import { BasicMenu } from '@client/new/components/BasicMenu/BasicMenu';
import emptyState from '../assets/extras-empty-state.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileArrowUp,
  faTags,
  faCircleDollar,
} from '@fortawesome/pro-regular-svg-icons';
import { Row, Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './ExtrasEmptyState.css';

export const ExtrasEmptyState = () => {
  const vm = extrasVM.useValue();
  const shouldShowEmptyState = vm.isExtrasEmpty && vm.formType !== 'ContentTab';

  if (!shouldShowEmptyState) return null;

  return (
    <Col gap="2xl" className={styles.container}>
      {/* Main content card */}
      <div className={styles.card}>
        <Row gap="3xl" responsive className={styles.cardRow}>
          <Col gap="xl" className={styles.contentSection}>
            <Typography variant="headline" size="small">
              Create your first Extra
            </Typography>

            <Col gap="l">
              {/* Feature 1 */}
              <Col gap="s">
                <Row gap="m" alignCenter>
                  <div className={styles.featureIcon}>
                    <FontAwesomeIcon icon={faFileArrowUp} />
                  </div>
                  <Typography variant="body" size="large" fontWeight="medium">
                    PDFs, Slides, Links and Videos
                  </Typography>
                </Row>
                <Typography
                  variant="body"
                  size="medium"
                  fontWeight="normal"
                  className={styles.featureDescription}
                >
                  Offer multiple content formats to your users
                </Typography>
              </Col>

              {/* Feature 2 */}
              <Col gap="s">
                <Row gap="m" alignCenter>
                  <div className={styles.featureIcon}>
                    <FontAwesomeIcon icon={faTags} />
                  </div>
                  <Typography variant="body" size="large" fontWeight="medium">
                    Sell individually or in groups
                  </Typography>
                </Row>
                <Typography
                  variant="body"
                  fontWeight="normal"
                  size="medium"
                  className={styles.featureDescription}
                >
                  Your content can be mixed or sold individually in "Offers" tab
                </Typography>
              </Col>

              {/* Feature 3 */}
              <Col gap="s">
                <Row gap="m" alignCenter>
                  <div className={styles.featureIcon}>
                    <FontAwesomeIcon icon={faCircleDollar} />
                  </div>
                  <Typography variant="body" size="large" fontWeight="medium">
                    Mix with programs
                  </Typography>
                </Row>
                <Typography
                  variant="body"
                  fontWeight="normal"
                  size="medium"
                  className={styles.featureDescription}
                >
                  You can offer them up together with your OTP fitness programs
                </Typography>
              </Col>
            </Col>

            <div className={styles.buttonWrapper}>
              <BasicMenu
                testId="extras-create-menu"
                title="Add new content"
                items={vm.extrasMenu}
                buttonColor="neutral"
              />
            </div>

            {/* <Col gap="m">
              <Typography variant="body" size="medium" fontWeight="bold">
                Learn more about most successful content strategies
              </Typography>
              <a
                href="#"
                className={styles.guideLink}
                onClick={(e) => e.preventDefault()}
              >
                <Typography variant="body" size="medium" fontWeight="bold">
                  Guide
                </Typography>
              </a>
            </Col> */}
          </Col>

          <div className={styles.imageSection}>
            <img
              src={emptyState}
              alt="Empty state illustration"
              className={styles.image}
            />
          </div>
        </Row>
      </div>
    </Col>
  );
};
